export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
    },
    value: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change', 'update:modelValue'],
  methods: {
    onClick() {
      this.$emit('change', this.value);
      this.$emit('update:modelValue', this.value);
    },
    onChange(e) {
      this.$emit('change', e.target.value);
      this.$emit('update:modelValue', e.target.value);
    },
  },
};
